import Main from './DataIntelligenceMain'

export default {
  Main,
}
